import React from "react";
import { Container, Col, Row, Form, FormGroup, Input, Button} from "reactstrap";
import Database from "./database/Database"

class YourView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      text: "",
      feedback:false
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    const scriptURL =
    `https://script.google.com/macros/s/AKfycby0kfnJ_QpsQFxjE5yUYoUvN1V--LIaCU5Yk4CjjnSMS7b6PyM/exec?overall=${this.state.text}&question1=${0}&question2=${0}&question3=${0}&question4=${0}&question0=${0}`;
    if (this.state.text!==""){
      this.setState({
        feedback: true
      });
    fetch(scriptURL)
      .then(response => console.log("Success!", response))
      .catch(error => console.error("Error!", error.message));
    }
  };


  handleChange = e => {
    this.setState({
      text: e.target.value
    });
  };

  render() {
    let feedback=this.state.feedback?<p className="whiteback text-center feedbackpad">Thank you for your feedback. Follow <a href="https://twitter.com/ajenglish" target="_blank" rel="noopener noreferrer">AJEnglish on Twitter</a> for more news and updates.</p>:<p>&nbsp;</p>
    return (
      <div className="fullscreen yourview">
        <Container fluid >
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col lg ="10" xs="12">
              <br/>
              <br/>
              <p className="text-center font-600 pad20top display-5">
              When do you think this will all end? 
              </p>
              <Form style={{display:this.state.feedback?"none":"block"}} onSubmit={this.handleSubmit} name="googlesheet">
                <FormGroup>
                  <Input style={{height:"150px"}}
                    type="textarea"
                    value={this.state.text}
                    onChange={this.handleChange}
                  />
                  <br/>
                  <section className="center">
                  <Button type="submit"  className="center">
                  Submit</Button>
                  </section>
                </FormGroup>
              </Form>
              {feedback}
            </Col>
          </Row>
        </Container>
      </Container>
        <Container fluid>
        <Container className="relatedsection">
        <Row className="justify-content-center align-items-center">
            <Col lg ="10" xs="12">
        <h4 className="text-left">ALSO READ</h4>
        <p className="grayline"></p>
          <Row className="justify-content-center align-items-center">
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5>What happens when coronavirus hits refugee camps?</h5>
          <a href="https://www.aljazeera.com/podcasts/thetake/2020/03/coronavirus-hits-refugee-camps-200330135843858.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/thetake.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5>Coronavirus testing methods: What you need to know</h5>
          <a href="https://www.aljazeera.com/news/2020/03/coronavirus-testing-methods-200330142718434.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/testing.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
          <h5>Will the global economy recover from COVID-19? | Start Here</h5>
          <a href="https://www.aljazeera.com/programmes/start-here/2020/04/global-economy-recover-covid-19-start-200407095907239.html" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/starthere.jpg' className="fluid" alt=""/></a>
          </Col>
          </Row>
          <br/>
          <Row className="justify-content-center align-items-center">
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5>Coronavirus: All you need to know about the symptoms and risks</h5>
          <a href="https://www.aljazeera.com/news/2020/01/coronavirus-symptoms-vaccines-risks-200122194509687.html?utm_source=website&utm_medium=article_page&utm_campaign=read_more_links" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/know.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
            <h5>How does coronavirus spread and how can you protect yourself?</h5>
          <a href="https://www.aljazeera.com/news/2020/01/coronavirus-spread-protect-200130115539072.html?utm_source=website&utm_medium=article_page&utm_campaign=read_more_links" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/project.jpg' className="fluid" alt=""/></a>
          </Col>
          <Col className="relatedbox" xl="4" lg="4" md="4" xs="12">
          <h5>Coronavirus: Which countries have confirmed new cases?</h5>
          <a href="https://www.aljazeera.com/news/2020/01/countries-confirmed-cases-coronavirus-200125070959786.html?utm_source=website&utm_medium=article_page&utm_campaign=read_more_links" target="_blank" rel="noopener noreferrer"><img src='./jpg/related/country.jpg' className="fluid" alt=""/></a>
          </Col>
          </Row>
          </Col>
          </Row>
          </Container>
          </Container>
      </div>
    );
  }
}

export default YourView;